import { render } from "./TopProductReviews.vue?vue&type=template&id=2993e7bc"
import script from "./TopProductReviews.vue?vue&type=script&lang=js"
export * from "./TopProductReviews.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__